import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SubdomainService } from './subdomain.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private apiUrl = environment.apiBaseUrl;

  constructor(
    private http: HttpClient,
    private subdomainService: SubdomainService
  ) {}

  // Get all users for the current subdomain
  getUsers(): Observable<any> {
    const subdomain = this.subdomainService.getSubdomain();
    return this.http.get(`${this.apiUrl}/api/users?subdomain=${subdomain}`);
  }

  // Get a specific user by ID
  getUserById(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/api/users/${id}`);
  }

  // Create a new user
  createUser(userData: any): Observable<any> {
    const subdomain = this.subdomainService.getSubdomain();
    userData.subdomain = subdomain;
    return this.http.post(`${this.apiUrl}/api/users`, userData);
  }

  // Update an existing user
  updateUser(id: number, userData: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/api/users/${id}`, userData);
  }

  // Delete a user
  deleteUser(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/api/users/${id}`);
  }

  // Update user roles
  updateUserRoles(id: number, roles: string[]): Observable<any> {
    return this.http.put(`${this.apiUrl}/api/users/${id}/roles`, { roles });
  }

  // Profile management methods
  
  // Get current user's profile
  getCurrentUserProfile(): Observable<any> {
    return this.http.get(`${this.apiUrl}/api/user/profile`);
  }

  // Update current user's profile
  updateCurrentUserProfile(profileData: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/api/user/profile`, profileData);
  }

  // Verify current password
  verifyCurrentPassword(currentPassword: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/api/user/verify-password`, { currentPassword });
  }
} 